import { useEffect, useState } from "react";

const navLinks = [
  { id: "today", label: "今日实锤" },
  { id: "list", label: "实锤名单" },
  { id: "topics", label: "热门栏目" },
  { id: "hot", label: "本周热榜" },
  { id: "faq", label: "吃瓜指南" },
  { id: "about", label: "关于我们" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid ? "bg-background-50/95 border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:h-[72px] md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-full text-xl ${
              solid ? "bg-primary-500" : "bg-primary-500"
            }`}
          >
            🍉
          </span>
          <span
            className={`font-heading text-xl tracking-wide transition-colors ${
              solid ? "text-foreground-900" : "text-foreground-900"
            }`}
          >
            吃瓜今天
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                solid
                  ? "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
                  : "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#today"
            className="hidden whitespace-nowrap items-center gap-1.5 rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            <i className="ri-fire-fill"></i>
            看今日合集
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-full text-xl text-foreground-800 hover:bg-background-100 md:hidden"
          >
            <i className={open ? "ri-close-line" : "ri-menu-line"}></i>
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}